/**
 * ========================
 * SALVATION TEAM DOMAIN MENU PROVIDER
 * ========================
 *
 * Menu configuration for the Salvation Team console.
 * Sections:
 *  1. Overview: Overview
 *  2. Follow-up: People, New decisions (the review queue for decisions from cards, forms, Planning Centre and
 *     spreadsheets)
 *  3. Teams: Campus teams
 *  4. Administration: Settings
 *
 * Visibility comes from SALVATION_PAGE_ACCESS in useSalvationPermissions, the same predicates the routes hand to
 * SalvationGate, so an item shows exactly when its page would open.
 */

import { IconDashboard, IconUsers, IconUsersGroup, IconSettings, IconInbox } from '@tabler/icons-react';
import { DomainMenuProvider, MenuSection } from '../../layouts/menu/types';
import { SALVATION_PAGE_ACCESS as page, salvationMenuVisibility as when } from '../../hooks/salvation/useSalvationPermissions';

class SalvationMenuProvider implements DomainMenuProvider {
  domainId = 'salvation';

  getMenuConfig() {
    const sections: MenuSection[] = [
      {
        id: 'salvation-overview',
        label: 'Overview',
        visible: when(page.overview),
        items: [{ id: 'salvation-dashboard', label: 'Overview', path: '/app/salvation', icon: <IconDashboard size={16} />, visible: when(page.overview) }],
      },
      {
        id: 'salvation-follow-up',
        label: 'Follow-up',
        visible: when(page.people, page.intake),
        items: [
          { id: 'salvation-people', label: 'People', path: '/app/salvation/people', icon: <IconUsers size={16} />, visible: when(page.people) },
          { id: 'salvation-intake', label: 'New decisions', path: '/app/salvation/intake', icon: <IconInbox size={16} />, visible: when(page.intake) },
        ],
      },
      {
        id: 'salvation-teams-section',
        label: 'Teams',
        visible: when(page.teams),
        items: [
          { id: 'salvation-teams', label: 'Campus teams', path: '/app/salvation/teams', icon: <IconUsersGroup size={16} />, visible: when(page.teams) },
        ],
      },
      {
        id: 'salvation-administration',
        label: 'Administration',
        visible: when(page.settings),
        items: [
          { id: 'salvation-settings', label: 'Settings', path: '/app/salvation/settings', icon: <IconSettings size={16} />, visible: when(page.settings) },
        ],
      },
    ];

    return {
      domainId: this.domainId,
      sections,
      metadata: {
        version: '1.0.0',
        lastUpdated: Date.now(),
        description: 'Salvation Team menu',
      },
    };
  }
}

export const salvationMenuProvider = new SalvationMenuProvider();
